import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomDateTimePipe } from '../core/pipes/CustomDateTime.pipe';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    providers: [CustomDateTimePipe],
    standalone: true,
    imports:[
        CommonModule,
        FormsModule,
        DialogModule,
        TranslateModule,
        CustomDateTimePipe
    ]
})
export class AppTopbarComponent {

    @ViewChild('menubutton') menuButton!: ElementRef;
    @ViewChild('searchinput') searchInput!: ElementRef;
    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;
    searchActive: boolean = false;
    userName: any = "";
    role: any = "";
    lastLogin: any = "";
    lastLoginFormatted: string = "";
    atWord: string = "at";
    previousLogin: any = "";
    previousLoginFormatted: string = "";

    approvalDialog: boolean = false;

    constructor(public layoutService: LayoutService, public el: ElementRef, private router: Router, private translate: TranslateService, private customDateTimePipe: CustomDateTimePipe) {
        let userObj: any = localStorage.getItem('userData');
        let previousLogin: any = localStorage.getItem('PreviousLogin');
        this.userName = JSON.parse(userObj).fullName;
        this.role = JSON.parse(userObj).role;
        this.lastLogin = JSON.parse(userObj).lastLogin;
        this.previousLogin = previousLogin;

    }
    ngOnInit() {
        this.updateLastLoginFormat();
    }

    updateLastLoginFormat() {
        this.translate.get('TOPBAR.AT').subscribe((at: string) => {
            this.atWord = at;
            if (this.lastLogin) {
                //const date = new Date(this.lastLogin);
                this.lastLoginFormatted = this.customDateTimePipe.transform(this.lastLogin);
            }
            if(this.previousLogin) {
                this.previousLoginFormatted = this.customDateTimePipe.transform(this.previousLogin);
            }
        });
    }
    checkRouteAndRedirect(): void {
        // Get the current route
        const currentUrl = this.router.url;
    
        if (currentUrl === '/app/registration-tracking') {
          // Show your popup if the user is on the '/app/registration-tracking' route
          this.approvalDialog = true;
        } else {
          // Redirect to '/app/registration-tracking' if they are not on this route
          this.router.navigate(['/app/account-settings']);
        }
      }
    activateSearch() {
        this.searchActive = true;
        setTimeout(() => {
            this.searchInput.nativeElement.focus();
        }, 100);
    }

    deactivateSearch() {
        this.searchActive = false;
    }
    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onConfigButtonClick() {
        this.layoutService.showConfigSidebar();
    }
    
    onSidebarButtonClick() {
        this.layoutService.showSidebar();
    }

    closePopup() {
        this.approvalDialog = false;
    }
}
